import * as NavConstants from 'constants/NavConstants';
import {ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as ChatDAO from 'llm/chat-library/ChatDAO';
import {ChatInputGlobalClientState} from 'llm/chat-library/ChatInput';
import {setInitialChatData} from 'llm/chat-library/InitialChatData';
import {openExistingChat} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import {AgentMode, mapAgentModeToAgentType} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';

/**
 * Runs a suggested question by creating a new chat in ASK mode with the question as the initial message.
 * Opens the AI sidepanel with the new chat.
 *
 * @param question - The question text to ask
 * @param fileId - The ID of the file the question is about
 * @param fileName - The name of the file the question is about
 * @returns Promise that resolves to the created chat ID
 */
export async function runSuggestedQuestion(
  question: string,
  fileId: string,
  fileName: string
): Promise<string> {
  const enrichedQuestion = `Regarding "${fileName}": ${question}`;

  // Construct message for ASK mode
  const message = {
    text: enrichedQuestion,
    fileUploads: [],
  };

  // Create new chat with ASK agent mode
  // ASK mode will automatically capture context from the active workspace
  const chatId = await ChatDAO.createChatSession(ChatType.DEEP_RESEARCH);
  const messagePromise = ChatDAO.sendMessage(chatId, AgentMode.ASK, message, {
    publicDataEnabled: false,
  });

  // Store initial chat data so the chat component can show loading state and initial message
  setInitialChatData(chatId, {
    message: {
      ...message,
      agentType: mapAgentModeToAgentType(AgentMode.ASK),
    },
    messagePromise,
  });

  // Update global state to remember that ASK mode was last used
  ChatInputGlobalClientState.updateState('', {
    lastUsedAgent: AgentMode.ASK,
    lastUsedPublicDataEnabled: false,
  });

  // Open the chat in the AI sidepanel without fully expanding it
  openExistingChat(chatId);
  SidepanelActions.openSection(NavConstants.SECTIONS.AI);

  return chatId;
}
